module.exports = __webpack_public_path__ + "media/images/application/template/CPA-email-header-041e709996d9c5eaa98bb4c6623a7fb7.png";